import React from "react";
import { Box, Icon, Fab, darken } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { makeStyles } from '@mui/styles';
import clsx from "clsx";

// common
import { dic } from "@common/text_defs"

const useStyles = makeStyles(({ palette, ...theme }) => ({
  introWrapper: {
    padding: "5rem 0px !important",
    overflow: "visible !important",
    background:
      "url(./images/img_bg0.jpg) center center/cover no-repeat",
    "& h1, h2, h3, h4, h5, h6": { color: "#fff", },

    [theme.breakpoints.down("sm")]: {
      padding: "100px 0 !important",
      backgroundColor: "#3F51B5",
      textAlign: "left",
      "& .list": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
    },
  },
  whiteButton: {
    background: "#fff !important",
    "&:hover": {
      background: `${darken("#ffffff", 0.1)} !important`,
    },
  },
  product: {
    position: "relative",
    top: "100px",
    "& img": {
      width: "100%",
      borderRadius: "0.5rem",
      boxShadow:
        "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)",
    },
    [theme.breakpoints.down("md")]: {
      left: 0,
      top: 0,
    },
  },
  productLink: {
    position: "absolute",
    top: "-100px",
    left: "-30px",
    textAlign: "center",
    display: "block",
    width: "160px",
    height: "160px",
    borderRadius: "50%",
    background: "#ffffff",
    color: "rgba(0, 0, 0, 0.87)",
    padding: "37px 20px",
    boxSizing: "border-box",
    overflow: "hidden",
    boxShadow: "0 14px 32px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease",

    "&:hover": { boxShadow: "0 19px 32px rgba(0, 0, 0, 0.4)" },

    [theme.breakpoints.down("md")]: {
      display: "none !important",
    },
  },
}));

const IntroSection = () => {
  const classes = useStyles();

  return (
    <Box component="section" className="section" id="intro" sx={{ pb: 0 }}>
      <Box className={classes.introWrapper}>
        <Box sx={{
          padding: "0px 1rem",
          maxWidth: "1170px",
          mx: 'auto'
        }}>
          <Grid container spacing={{xs:1,sm:3}} justify="center">
            <Grid >
              <Box component="h3" sx={{textShadow: "0 4px 4px rgba(0, 0, 0, 0.22)", mb:2, ml:2}}>
              私たちは、トレーディング、人工知能、ストラクチャリングの知識を駆使してこれからのビジネスを考えていきます。
              </Box>
              <Box sx={{ ml:2, fontSize:'22px', color: "#ffffff" }}>
                <div dangerouslySetInnerHTML={{ __html: dic.home.intro_1 }}></div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export { IntroSection };
